import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { ListItem, ListItemIcon, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        active: {
            color: theme.palette.secondary.main,
            '& div': {
                color: theme.palette.secondary.main
            }
        },
        item: {
            justifyContent: 'center',
            alignItems: 'center',
            height: theme.deloitte.menuSize
        },
        itemIcon: {
            minWidth: 0,

        }
    })
);
interface DeloitteListItemLinkProps {
    icon: any;
    to: string;
}
export const DeloitteListItemLink: FC<DeloitteListItemLinkProps> = (props) => {
    const { icon, to } = props;
    const classes = useStyles();
    const IconI = icon;
    return (
        <ListItem button className={classes.item} component={NavLink} to={to} activeClassName={classes.active}>
            <ListItemIcon className={classes.itemIcon}><IconI /></ListItemIcon>
        </ListItem>
    );
}